import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Header from "../components/Header.jsx";
import Footer from "../components/Footer.jsx";

export default function RewardPage() {
  const [params] = useSearchParams();
  const event = params.get("event") || "";
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    const url = event
      ? `/api/reward-config?event=${encodeURIComponent(event)}`
      : "/api/reward-config";
    fetch(url).then((r) => r.json()).then(setCfg);
  }, [event]);

  const featured = (cfg?.offers || []).filter((o) => o.featured);
  const extras = (cfg?.offers || []).filter((o) => !o.featured);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 max-w-3xl mx-auto w-full px-6 py-16">
        <div className="text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-flame/15 border border-flame/30 mb-6">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="text-flame">
              <path d="M5 12l5 5L20 7" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <h1 className="text-4xl md:text-6xl font-bold tracking-tight">
            Thanks — <span className="text-flame">you're in</span>.
          </h1>
          <p className="mt-5 text-lg text-white/70 max-w-xl mx-auto">
            Your review is in moderation. I read every word — your feedback is
            critical to how I improve our products and grow our business.
            Below are some resources I think you'll find useful.
          </p>
        </div>

        {!cfg ? (
          <p className="mt-12 text-center text-white/50">Preparing your downloads…</p>
        ) : (
          <>
            {featured.length ? (
              <section className="mt-12 space-y-3">
                <h2 className="text-xs uppercase tracking-widest text-flame font-semibold mb-3">
                  Your reward
                </h2>
                {featured.map((o, i) => (
                  <OfferCard key={"f" + i} offer={o} variant="featured" />
                ))}
              </section>
            ) : null}

            <section className="mt-12 space-y-3">
              <h2 className="text-xs uppercase tracking-widest text-white/50 font-semibold mb-3">
                {featured.length ? "More from The AIE Network" : "Resources from The AIE Network"}
              </h2>
              <div className="grid sm:grid-cols-2 gap-3">
                {extras.map((o, i) => (
                  <OfferCard key={"e" + i} offer={o} variant="extra" />
                ))}
              </div>
            </section>
          </>
        )}

        <p className="mt-16 text-center text-sm text-white/40">
          Want to share more? <a className="underline hover:text-flame" href="/submit">Leave another review</a>.
        </p>
      </main>
      <Footer />
    </div>
  );
}

function OfferCard({ offer, variant }) {
  const isLink = offer.mode === "link";
  const isRedirect = offer.mode === "redirect";
  const isDownload = !isLink && !isRedirect;
  const featured = variant === "featured";

  const ariaIcon = (
    <span aria-hidden="true" className="text-2xl flex-none">
      {offer.icon || (isDownload ? "📥" : "🔗")}
    </span>
  );

  return (
    <a
      href={offer.url}
      target={isLink || isRedirect ? "_blank" : undefined}
      rel={isLink || isRedirect ? "noopener noreferrer" : undefined}
      {...(isDownload ? { download: "" } : {})}
      className={`card p-5 flex items-start gap-4 transition hover:border-flame/50 group ${
        featured ? "border-flame/40 bg-flame/[0.04]" : ""
      }`}
    >
      {ariaIcon}
      <div className="flex-1 min-w-0">
        <div className="font-semibold flex items-center gap-2">
          {offer.label}
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="opacity-0 group-hover:opacity-100 transition text-flame">
            <path d="M5 12h14m-7-7l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        {offer.description ? (
          <div className="text-sm text-white/60 mt-0.5">{offer.description}</div>
        ) : null}
        {offer.price > 0 ? (
          <div className="text-xs text-white/40 mt-1">Normally ${offer.price}, free for reviewers.</div>
        ) : null}
      </div>
    </a>
  );
}
